import { ISetCustomerData } from "@interfaces";
import ftApiClient from "./ftApiClient";

export const redeemerApi = {
    updateRedeemer: (params: ISetCustomerData[]) => {
        const url = "cart/redeemers";
        return ftApiClient.put(url, params);
    },
    getRedeemer: () => {
        const url = "cart/redeemers";
        return ftApiClient.get(url);
    },
    AddRedeemer: (params:ISetCustomerData) => {
        const url = "cart/redeemers";
        return ftApiClient.post(url, params);
    },
};
